import React from "react";
import { CloudUpload } from "@mui/icons-material";

import { useLayerPanelContext } from "fond/project/panels/InputPanel/LayerPanelContext";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

interface LayerUploadActionProps {
  /** Defaults to opening the `${layerKey}-upload` screen. */
  onClick?: () => void;
}

/**
 * `LayerPanel` action for uploading data to the layer.
 */
const LayerUploadAction: React.FC<LayerUploadActionProps> = ({ onClick }) => {
  const { layerKey } = useLayerPanelContext();
  const { open } = useStackedNavigationContext();

  return (
    <StackedNavigationButton
      data-testid={`upload-${layerKey}-button`}
      icon={<CloudUpload />}
      title="Upload"
      subtitle="Use my data"
      onClick={onClick ?? (() => open(`${layerKey}-upload`))}
    />
  );
};

export default LayerUploadAction;
